<script>
    export let color
</script>

<svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.22217 10.0455L7.6686 15.5L19.6507 3.5" stroke={color} stroke-width="3" stroke-linecap="square"/>
</svg>
    